"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerWithState = exports.BlockState = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _eventer = require("@blockwell/eventer");
class BlockState {
  constructor(key, spec, type, registry, block) {
    (0, _defineProperty2.default)(this, "ctx", null);
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer());
    this.key = key;
    this.spec = spec;
    this.type = type;
    this.registry = registry;
    this.block = block;
  }
  layoutValue() {
    let value = this.type.events.getLastValue("value");
    if (typeof (value === null || value === void 0 ? void 0 : value.layout) === "string") {
      return value.layout;
    }
    return undefined;
  }
}
exports.BlockState = BlockState;
class ManagerWithState {
  get context() {
    return this.state.ctx;
  }
  get events() {
    return this.state.events;
  }
  get key() {
    return this.state.key;
  }
  get spec() {
    return this.state.spec;
  }
  get type() {
    return this.state.type;
  }
  get registry() {
    return this.state.registry;
  }
  get block() {
    return this.state.block;
  }
  constructor(state) {
    this.state = state;
  }
}
exports.ManagerWithState = ManagerWithState;
//# sourceMappingURL=BlockState.js.map